import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './AdminHome.css';

const AdminHome = ({ onNavigate, user, usersCount, pdfsCount }) => {
  const cards = [
    {
      id: 'users',
      title: 'Gestão de Usuários',
      description: 'Criar, editar e gerenciar usuários do sistema',
      icon: '👤',
      features: ['Criar usuários', 'Alterar senhas', 'Definir permissões', 'Relatórios de acesso'],
      count: usersCount,
      countLabel: 'usuários'
    },
    {
      id: 'pdfs',
      title: 'Gestão de Revistas Digitais',
      description: 'Visualizar, organizar e controlar revistas digitais',
      icon: '📄',
      features: ['Upload de Revistas', 'Organização', 'Controle de acesso', 'Histórico de versões'],
      count: pdfsCount,
      countLabel: 'documentos'
    }
  ];

  return (
    <Container fluid className="admin-home py-4" style={{ backgroundColor: '#181d34', minHeight: '100vh' }}>
      {/* Header Section */}
      <div className="mb-4" style={{ backgroundColor: '#353b4b', margin: '-1.5rem -1.5rem 1.5rem -1.5rem', padding: '2rem 1.5rem', borderRadius: '0 0 20px 20px', position: 'relative', overflow: 'hidden' }}>
        {/* Background decoration */}
        <div 
          className="position-absolute"
          style={{
            top: '10px',
            right: '10%',
            width: '80px',
            height: '80px',
            backgroundColor: '#2cabba',
            borderRadius: '50%',
            opacity: '0.08'
          }}
        ></div>
        
        <Row>
          <Col>
            <div className="welcome-section text-center position-relative">
              {/* Icon */}
              <div 
                className="d-inline-flex align-items-center justify-content-center mb-3"
                style={{
                  width: '50px',
                  height: '50px',
                  backgroundColor: '#2cabba',
                  borderRadius: '12px',
                  fontSize: '1.5rem'
                }}
              >
                ⚙️
              </div>
              
              <h1 className="h2 mb-2 text-dark fw-bold">
                Painel Administrativo
              </h1>
              
              <div className="mb-2">
                <p className="mb-1" style={{ color: '#2cabba', fontSize: '1.1rem' }}>
                  Bem-vindo, <strong>{user?.firstName} {user?.lastName}</strong>
                </p>
                <div className="d-flex align-items-center justify-content-center">
                  <div 
                    className="me-2"
                    style={{
                      width: '6px',
                      height: '6px',
                      backgroundColor: '#2cabba',
                      borderRadius: '50%',
                      animation: 'pulse 2s infinite'
                    }}
                  ></div>
                  <small className="text-dark">Administrador • Sistema Online</small>
                </div>
              </div>
              
              <p className="text-dark mb-0 small">
                Selecione uma das opções abaixo para gerenciar o sistema
              </p>
            </div>
          </Col>
        </Row>
      </div>

      <Row className="g-4 justify-content-center">
        {cards.map((card) => (
          <Col key={card.id} xs={12} sm={12} md={6} lg={5}>
            <Card 
              className="admin-card h-100 border-0 shadow-lg"
              onClick={() => onNavigate(card.id)}
              style={{ 
                cursor: 'pointer',
                backgroundColor: '#353b4b',
                transition: 'all 0.3s ease',
                borderRadius: '15px'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 0 30px rgba(44, 171, 186, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
              }}
            >
              <Card.Body className="p-4">
                {/* Header Section */}
                <div className="d-flex align-items-start mb-4">
                  <div 
                    className="d-flex align-items-center justify-content-center me-4"
                    style={{
                      width: '60px',
                      height: '60px',
                      backgroundColor: '#2cabba',
                      borderRadius: '15px',
                      fontSize: '2rem'
                    }}
                  >
                    {card.icon}
                  </div>
                  <div className="flex-grow-1">
                    <Card.Title className="h4 mb-2 text-white">
                      {card.title}
                    </Card.Title>
                    <Card.Text className="text-light mb-0" style={{ fontSize: '0.95rem' }}>
                      {card.description}
                    </Card.Text>
                  </div>
                </div>

                {/* Features Section */}
                <div className="mb-4">
                  <h6 className="text-light mb-3" style={{ fontWeight: '600' }}>
                    Funcionalidades:
                  </h6>
                  <Row className="g-2">
                    {card.features.map((feature, idx) => (
                      <Col key={idx} xs={6}>
                        <div className="d-flex align-items-center">
                          <div 
                            className="me-2"
                            style={{
                              width: '6px',
                              height: '6px',
                              backgroundColor: '#2cabba',
                              borderRadius: '50%'
                            }}
                          ></div>
                          <small className="text-light" style={{ fontSize: '0.85rem' }}>
                            {feature}
                          </small>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>

                {/* Stats and Action Section */}
                <div className="d-flex justify-content-between align-items-center pt-3 border-top" style={{ borderColor: '#6c757d !important' }}>
                  <div className="text-center">
                    <div 
                      className="h2 mb-1 fw-bold"
                      style={{ color: '#2cabba' }}
                    >
                      {card.count}
                    </div>
                    <div className="small text-light" style={{ fontSize: '0.8rem' }}>
                      {card.countLabel}
                    </div>
                  </div>
                  
                  <div
                    className="btn text-white fw-semibold px-4 py-2 d-flex align-items-center"
                    style={{
                      backgroundColor: '#2cabba',
                      borderRadius: '10px',
                      border: 'none',
                      fontSize: '0.9rem'
                    }}
                  >
                    Gerenciar
                    <i className="ms-2" style={{ fontSize: '0.8rem' }}>→</i>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default AdminHome;